import { Icon } from "@mui/material";
import { useState } from "react";
import UserDetails from "./UserDetails";
import WrapperModal from "../ui/WrapperModal";
import { useMutation, useQueryClient } from 'react-query';
import { deleteUser } from "../../api/hospitalsAPI";
import ConfirmationWarning from "../ui/ConfirmationWarning";

const UserTable = ({ data }) => {
  const [detailsPanel, setDetailsPanel] = useState(false);
  const [deletePanel, setDeletePanel] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const queryClient = useQueryClient();

  const cancelStudyCreationHandler = () => {
    setDetailsPanel(false);
    setDeletePanel(false);
  };

  const detailsUser = (user) => {
    setUserDetails(user); 
    setDetailsPanel(true);
  };

  const { mutate: deleteUserMutation } = useMutation(deleteUser, {
    onSuccess: () => {
      queryClient.invalidateQueries(['users-list']);
      setDeletePanel(false);
    },
    onError: (error) => {
      console.error("Error deleting user", error);
    }
  });

  const handleDelete = (user) => {
    setUserToDelete(user); 
    setDeletePanel(true);
  };

  const info = data;

  return (
    <table className="rounded-table">
      <thead>
        <tr className="hospital-table">
          <th>Name</th>
          <th>Email</th>
          <th>Role</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {info.map((row, index) => {
          const changeRole = row.role === 'HOSPITAL' ? 'ADMIN' : row.role;
          return (
            <tr key={index}>
              <td>{`${row.firstname} ${row.lastname}`}</td>
              <td>{`${row.email}`}</td>
              <td>{`${changeRole}`}</td>
              <td>
                <div className="icon-container">
                  <Icon className="icon" onClick={() => detailsUser(row)}>visibility</Icon>
                  <Icon className="icon" onClick={() => handleDelete(row)}>delete</Icon>
                </div>
              </td>
            </tr>
          );
        })}
      </tbody>

      {detailsPanel && (
        <WrapperModal onDismiss={cancelStudyCreationHandler}>
          <UserDetails
            userId={userDetails._id} 
            onDecline={cancelStudyCreationHandler}
          />
        </WrapperModal>
      )} 
      {deletePanel && (
        <WrapperModal onDismiss={cancelStudyCreationHandler}>
          <ConfirmationWarning
            title={`Are you sure you want to delete the user ${userToDelete.firstname} ${userToDelete.lastname}?`}
            acceptLabel={'Continue'}
            declineLabel={'Close'}
            onAccept={() => {
              deleteUserMutation(userToDelete._id);
            }}
            onDecline={() => setDeletePanel(false)}
          />
        </WrapperModal>
      )}
    </table>
  );
};
export default UserTable;